import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {SOCIALS_WIDGET_SERVICES} from './socials-widget-services';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: object;
}

@Component({
    selector: 'socials-widget-modal',
    templateUrl: './socials-widget-modal.component.html',
    styleUrls: ['./socials-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialsWidgetModalComponent {
    services = SOCIALS_WIDGET_SERVICES;
    form = new FormGroup({});

    constructor(
        private dialogRef: MatDialogRef<SocialsWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService
    ) {
        this.services.forEach(service => {
            this.form.addControl(service.type, new FormControl());
        });
        if (data.config) {
            this.form.patchValue(data.config);
        }
    }

    createOrUpdate() {
        this.editor
            .crupdateWidget(this.data.widgetId, 'socials', this.form.value)
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
